export default "__VITE_PUBLIC_ASSET__98efa928__"